import { portalConfig } from "../config/applications";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer__inner">
        <Logo inverse />
        <span>Project / Technology Department</span>
        <span>© {new Date().getFullYear()} PRT Technology</span>
        <a href={portalConfig.productionUrl}>Internal demonstration portal</a>
        <a href="#disclaimer-title">Privacy &amp; disclaimer</a>
      </div>
    </footer>
  );
}
